import { render } from "./order_waybill.vue?vue&type=template&id=f60af8fa&scoped=true"
import script from "./order_waybill.vue?vue&type=script&lang=js"
export * from "./order_waybill.vue?vue&type=script&lang=js"

import "./order_waybill.vue?vue&type=style&index=0&id=f60af8fa&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60af8fa"]])

export default __exports__